function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 27.21875 4.375 L 23.8125 8.625 L 20.59375 6.1875 L 19.8125 5.625 L 19.21875 6.375 L 15.71875 10.75 L 12.4375 9.09375 L 11.65625 8.71875 L 11.15625 9.4375 L 7.75 14.5625 L 4.59375 12.1875 L 3.40625 13.8125 L 7.40625 16.8125 L 8.25 17.4375 L 8.84375 16.5625 L 12.34375 11.3125 L 15.5625 12.90625 L 16.28125 13.25 L 16.78125 12.625 L 20.1875 8.375 L 23.40625 10.8125 L 24.1875 11.375 L 24.78125 10.625 L 28.78125 5.625 L 27.21875 4.375 z M 27 12 L 27 28 L 29 28 L 29 12 L 27 12 z M 19 15 L 19 28 L 21 28 L 21 15 L 19 15 z M 11 16 L 11 28 L 13 28 L 13 16 L 11 16 z M 23 17 L 23 28 L 25 28 L 25 17 L 23 17 z M 3 18 L 3 28 L 5 28 L 5 18 L 3 18 z M 15 18 L 15 28 L 17 28 L 17 18 L 15 18 z M 7 21 L 7 28 L 9 28 L 9 21 L 7 21 z"
  }));
};

export default __webpack_public_path__ + "static/media/combo-chart.4cbd26af.svg";
export { SvgComponent as ReactComponent };